import React from 'react';

const CuentaCreadaPage = ({ setCurrentPage }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Barra superior azul */}
      <div className="bg-[#2c5282] h-3 w-full"></div>
      
      {/* Contenido principal */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white p-12 rounded-lg shadow-md w-full max-w-md text-center">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-pink-500 via-purple-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-lg transform -rotate-12">
              <span className="text-white font-bold text-2xl transform rotate-12">eSic</span>
            </div>
          </div>

          {/* Título */}
          <h1 className="text-[#2c5282] font-bold text-xl mb-1">
            Sistema Académico
          </h1>
          <p className="text-gray-600 text-sm mb-8">
            Escuela Boliviana<br />
            Intercultural de Danza
          </p>

          {/* Mensaje de éxito */}
          <p className="text-gray-700 text-base mb-8">
            ¡Tu cuenta fue creada con éxito!
          </p>

          {/* Botón Volver */}
          <button
            onClick={() => setCurrentPage && setCurrentPage('login')}
            className="bg-[#2c5282] text-white px-16 py-3 rounded-full font-semibold hover:bg-[#1e3a5f] transition-colors"
          >
            Volver
          </button>

          {/* Texto informativo */}
          <p className="text-gray-600 text-sm mt-8 leading-relaxed">
            Hemos enviado tu usuario al correo electrónico registrado. Revisa tu bandeja.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CuentaCreadaPage;